// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AppInfoComponentModel from '../../model/app-info-component-model';
import AppInfoComponentDTO from '../dto/app-info-component-dto';

export default abstract class AppInfoComponentModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AppInfoComponentDTO>) {
    super();
    if (data) {
      this.title = data.title ?? undefined;
      this.version = data.version ?? undefined;
      this.healthEndpoint = data.healthEndpoint ?? undefined;
    }
  }
  /**
  */
  'title'?: string;
  /**
  */
  'version'?: string;
  /**
  */
  'healthEndpoint'?: string;

  static toModel(dto: DeepPartial<AppInfoComponentDTO>): AppInfoComponentModel;
  static toModel(dto: DeepPartial<AppInfoComponentDTO> | undefined | null): AppInfoComponentModel | undefined;
  static toModel(dto: DeepPartial<AppInfoComponentDTO> | undefined | null): AppInfoComponentModel | undefined {
    return dto ? new AppInfoComponentModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AppInfoComponentModel> | AppInfoComponentModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'title': unwrapped.title,
      'version': unwrapped.version,
      'healthEndpoint': unwrapped.healthEndpoint,
    } as AppInfoComponentDTO;
  }
}
